export default (_, __, { t }) => t('page_title_default');
